import { CalendarDays, Clock, ClipboardList, MessageSquare, Zap, TrendingUp, Palette, Share2, KeyRound, Rocket, BookOpen, Gift } from "lucide-react";

/**
 * Secciones del panel, en el orden en que salen los chips en móvil (el de siempre).
 * `group` arma el sidebar de escritorio (dentro de cada grupo se respeta este orden).
 * `short` es la etiqueta corta para los chips.
 */
export const NAV_ITEMS = [
  { id: "appointments", label: "Citas", icon: CalendarDays, group: "agenda" },
  { id: "incomes", label: "Ingresos", icon: TrendingUp, group: "business" },
  // Solo con el add-on contratado (subscription.addons.loyaltyCards); si no, ni aparece.
  { id: "loyalty", label: "Lealtad", icon: Gift, group: "business", addon: "loyaltyCards" },
  { id: "schedule", label: "Horarios", icon: Clock, group: "agenda" },
  { id: "services", label: "Servicios", icon: ClipboardList, group: "agenda" },
  { id: "bot", label: "Bot de WhatsApp", short: "Bot", icon: MessageSquare, group: "whatsapp" },
  { id: "colors", label: "Personalización", icon: Palette, group: "business" },
  { id: "social", label: "Redes sociales", short: "Redes", icon: Share2, group: "business" },
  { id: "connections", label: "Conexiones", icon: Zap, group: "whatsapp" },
  { id: "account", label: "Mi cuenta", icon: KeyRound, group: "account" },
];

/**
 * La sección "guide" cambia de sitio y de nombre con el estado del negocio: mientras
 * falte configuración va primera ("Primeros pasos"); al completarla, al final
 * ("Así funciona"). `tour` es el ancla data-tour del ítem en la navegación.
 */
export const GUIDE_PENDING = { id: "guide", label: "Primeros pasos", icon: Rocket, group: "start", tour: "nav.guide" };
export const GUIDE_DONE = { id: "guide", label: "Así funciona", icon: BookOpen, group: "account", tour: "nav.guide" };

export const NAV_GROUPS = [
  { id: "start", label: "" },
  { id: "agenda", label: "Agenda" },
  { id: "whatsapp", label: "WhatsApp" },
  { id: "business", label: "Negocio" },
  { id: "account", label: "" },
];

/** Un profesional (staff) solo ve su agenda, horarios, conexiones y cuenta (la guía habla de servicios y bot, que no puede tocar). */
export const STAFF_HIDDEN = ["incomes", "services", "bot", "colors", "social", "guide"];

/** Con suscripción inactiva estas secciones se deshabilitan. */
export const NEEDS_SUBSCRIPTION = ["bot", "services", "connections", "loyalty"];
